<script>
import { fileHelper } from "@/helpers/index";
import VueEasyLightbox from 'vue-easy-lightbox'
import ModalFrame from "@/components/modals/ModalFrame.vue";

export default {
  name: "AppAlert",

  components: {
    VueEasyLightbox,
    ModalFrame,
  },

  data() {
    return {
      showLightbox: false,
      showPreview: false,
    }
  },

  props: {
    fileLink: { type: String, default: '' },
    fileExtension: { type: String, default: '' },
	height: {
		type: String,
		default: '400px',
	},
	width: {
		type: String,
		default: '100%',
	},
  },
  
  computed: {
    fileType() {
      return fileHelper.getFileType(this.fileExtension);
    }
  },
}
</script>

<template>
  <div>
    <h5 v-if="!fileLink" class="text-gray-darker font-size-14">N/A</h5>
    <!-- Document Preview -->
    <div v-else-if="fileLink && fileType === 'document'">
      <div
        class="document-preview cursor-pointer"
        @click="showPreview = true"
      >
        <div
          class="pe-none position-relative overflow-hidden d-flex justify-content-center p-2"
        >
          <embed
            :src="`${fileLink}#toolbar=0`"
            height="400px"
            type="application/pdf"
            style="overflow: hidden !important;"
          >
          <div class="document-mask text-primary d-flex justify-content-center align-items-center">
            <span class="border-bottom border-primary">Preview</span>
          </div>
        </div>
      </div>
    </div>
    <!-- Image Preview -->
    <div v-else-if="fileLink && fileType === 'image'">
      <div
        class="document-preview cursor-pointer"
        @click="showLightbox = true"
      >
        <div class="position-relative p-2">
          <img
            :src="fileLink"
            class="object-contain"
            :width="width"
            :height="height"
          />
          <div class="document-mask text-primary d-flex justify-content-center align-items-center">
            <span class="border-bottom border-primary">Preview</span>
          </div>
        </div>
      </div>
      <vue-easy-lightbox
        :visible="showLightbox"
        :imgs="fileLink"
        @hide="showLightbox = false"
      ></vue-easy-lightbox>
    </div>

    <ModalFrame
      v-if="showPreview"
      :link="fileLink"
      @close="showPreview = false"
    ></ModalFrame>
  </div>
</template>

<style lang="scss" scoped>
.document-preview {
  .document-mask {
    opacity: 0;
    transition: 0.3s;
  }

  &:hover {
    .document-mask {
      opacity: 1;
      transition: 0.3s;
    }
  }
}

.document {
  &-preview {
    border: 2px dashed #ced4da;
    border-radius: 5px;
    padding: 20px;
  }
  &-mask {
    background-color: #e5e5e5;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 5px;
  }
}
</style>